module.exports = __webpack_public_path__ + "media/03_ASANBUDAPEST-BASS03.bb6d808a.mp3";